import { lazy, Suspense } from 'react'
import { Outlet, Route, Routes as RoutesReact } from 'react-router-dom'

import { Auth0ProviderWithNavigate } from 'components/auth0/Auth0ProviderWithNavigate'
import { AuthenticationGuard } from 'components/auth0/AuthenticationGuard'

const Nmap = lazy(() => import('../pages/nmap'))
const CallBackPage = lazy(() => import('pages/Callback'))

export default function Routes() {
  return (
    <Suspense fallback={<div className="min-h-screen bg-slate-50" aria-busy="true" />}>
      <RoutesReact>
        {/* <Route exact path="/" element={<Login />} /> */}
        <Route
          path="/"
          element={
            <Auth0ProviderWithNavigate>
              <Outlet />
            </Auth0ProviderWithNavigate>
          }
        >
          <Route index element={<AuthenticationGuard component={Nmap} />} />
          <Route path="/callback" element={<CallBackPage />} />
        </Route>
        {/* <Route path="/home"  element={<Nmap/>} /> */}
        <Route path="*" element={<h1>Page not found</h1>} />
      </RoutesReact>
    </Suspense>
  )
}
